import React from 'react';
import { FlagIcon } from '@heroicons/react/24/solid';
import type { FollowUpAction } from '../../pages/RunProgressPage/runProgressTypes';

interface FollowUpIndicatorProps {
  followUp?: FollowUpAction | null;
  className?: string;
}

const URGENCY_COLORS: Record<string, string> = {
  high:   'text-red-400',
  medium: 'text-amber-400',
  low:    'text-slate-400',
};

const FollowUpIndicator: React.FC<FollowUpIndicatorProps> = ({ followUp, className = '' }) => {
  if (!followUp?.action_required) return null;
  const color = URGENCY_COLORS[followUp.urgency ?? ''] ?? 'text-amber-400';

  return (
    <span className={`inline-flex items-center ${color} ${className}`} title={followUp.description ?? 'Follow-up required'}>
      <FlagIcon className="h-3.5 w-3.5" />
    </span>
  );
};

export default FollowUpIndicator;
